import styled from 'styled-components';

export default styled.p`
  font-size: 20px;
  color: #3b4f63;
  font-family: Roboto;
  margin: 0 0 8px;
`;
